import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';

import { CimaCore } from 'core/services';

@Component({
    selector: 'xm-base',
    styleUrls: [ './base.scss' ],
    templateUrl: './base.html'
})
export class BaseComponent implements OnInit {
    public removeNavHeight: boolean;
    public isBusinessUser: boolean;

    private cimaCore: CimaCore;
    private state: StateService;

    constructor(cimaCore: CimaCore, state: StateService) {
        Object.assign(this, { cimaCore, state });

    }

    public ngOnInit(): void {
        this.cimaCore.initUserData();

        this.isBusinessUser = this.cimaCore.isBusinessUser;
        this.removeNavHeight = this.state.current.name === 'account.u.standalone-cpc' || this.state.current.name === 'standalone-cpc.landing';
    }
}
